<template>
  <div class="college">
    <header v-if="$route.query.isApp">
      <van-icon
        :name="language === 'fa' ? 'arrow' : 'arrow-left'"
        @click="goAppBack"
      />
      <span>{{ $t("300181") }}</span>
    </header>
    <main>
      <div
        @click="
          $router.push({
            path: '/news',
            query: {
              isApp: $route.query.isApp,
              language: $route.query.language
            }
          })
        "
        class="college_Journalism"
      >
        <div>
          <b>{{ $t("300182") }}</b>
          <p>
            {{ $t("300185") }}
          </p>
          <van-button color="rgba(74, 148, 248, 1)">{{
            $t("300089")
          }}</van-button>
        </div>
        <div class="Journalism_img">
          <img src="../../assets/images/image_news@2x.png" alt="" />
        </div>
      </div>
      <div class="max-box">
        <div class="left_box">
          <div
            class="data_box"
            @click="
              $router.push({
                path: 'dataPage',
                query: {
                  isApp: $route.query.isApp,
                  language: $route.query.language
                }
              })
            "
          >
            <div>
              <div>
                <b>{{ $t("300183") }}</b>
              </div>
              <van-button color="rgba(239, 125, 98, 1)">{{
                $t("300089")
              }}</van-button>
            </div>
            <div>
              <img src="../../assets/images/image_date@2x.png" alt="" />
            </div>
          </div>
          <div @click="tourl" class="video_box">
            <div>
              <div>
                <b>{{ $t("300189") }}</b>
              </div>
              <van-button color="rgba(240, 149, 77, 1)">{{
                $t("300089")
              }}</van-button>
            </div>
            <div class="video_img">
              <img src="../../assets/images/image_video@2x.png" alt="" />
            </div>
          </div>
        </div>
        <div
          class="study_box"
          @click="
            $router.push({
              path: '/study',
              query: {
                isApp: $route.query.isApp,
                language: $route.query.language
              }
            })
          "
        >
          <div>
            <b>{{ $t("300184") }}</b>
            <p>
              {{ $t("300187") }}
            </p>
            <van-button color="rgba(12, 170, 109, 1)">{{
              $t("300089")
            }}</van-button>
          </div>
          <div class="study_img">
            <img src="../../assets/images/image_study@2x.png" alt="" />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { setCookie, removeToken, getCookie, setToken } from "../../utils/auth";
import { getvediourl } from "../../api/resource.js";
import { Button, Icon } from "vant";
import { mapGetters } from "vuex";
import { getUserInfo } from "../../api/user";
export default {
  name: "index",
  components: { vanButton: Button, vanIcon: Icon },
  data() {
    return {
      token: "",
      url: "",
      language: "",
      userInfo: {},
      isApp: ""
    };
  },
  created() {
    this.resher();
    getvediourl().then(res => {
      this.url = res.data;
    });
  },
  computed: {
    ...mapGetters(["isDirection"])
  },
  methods: {
    tourl() {
      console.log({link:this.url ? this.url : ""});
      this.$jsBridge.callHandler(
        this.$jsBridgeCmd.goBrowser,
        { code: 200, link: this.url ? this.url : "" },
        data => {}
      );
    },
    goAppBack() {
      this.$jsBridge.callHandler(this.$jsBridgeCmd.goBack, {}, data => {});
    },
    getUserInfo() {
      //获取用户信息
      getUserInfo().then(res => {
        if (res.code == 403 || res.code == 413) {
          this.appLogout();
          return false;
        }
        if (res.data) {
          this.userInfo = res.data;
          setCookie("userInfo", JSON.stringify(res.data));
        }
      });
    },
    appLogin() {
      if (this.isApp == 1) {
        this.$jsBridge.callHandler(
          this.$jsBridgeCmd.appLogin,
          { code: 200, type: "login" },
          data => {}
        );
      } else {
        return false;
      }
    },
    appLogout() {
      var _this = this;
      this.$jsBridge.callHandler(
        this.$jsBridgeCmd.appLogout,
        { code: 200 },
        data => {
          _this.isLogin = false;
          removeToken();
          removeCookie("userInfo");
          _this.appLogin();
        }
      );
    },
    resher() {
      // Toast(this.$route.query.token ? "有token-测试用" : "没有token-测试用");
      this.isApp = this.$route.query.isApp;
      var token = this.$route.query.token;
      this.$store.dispatch("setisApp", this.$route.isApp);
      this.$store.dispatch(
        "setIsDirection",
        this.$route.query.language == "fa" ? true : false
      );
      setCookie(
        "language",
        this.$route.query.language ? this.$route.query.language : "en"
      );
      this.language = this.$route.query.language
        ? this.$route.query.language
        : "en";
      window.document.documentElement.setAttribute(
        "dir",
        this.isDirection ? "rtl" : "ltr"
      );
      if (this.isApp == 1) {
        this.$i18n.locale = this.language;
        if (token) {
          setToken(token);
          this.isLogin = true;
          this.getUserInfo();
        } else {
          removeToken();
          this.isLogin = false;
        }
      } else {
        this.isLogin = getCookie("token") ? true : false;
        if (this.isLogin) {
          this.getUserInfo();
        } else {
          removeToken();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/variableName";
@import "../../style/mixin";
.overflow {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.buttonstyle {
  max-width: torem(68);
  height: torem(24);
  line-height: torem(24);
  margin-top: torem(12);
}
.img {
  width: torem(50);
  width: torem(50);
}
@mixin between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@mixin around {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.college {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  box-sizing: border-box;
  header {
    height: torem(38);
    line-height: torem(38);
    padding: 0 torem(16);
    .van-icon {
      font-size: torem(18);
      line-height: torem(38);
    }
    span {
      display: inline-block;
      width: calc(100% - #{torem(36)});
      font-size: torem(18);
      text-align: center;
    }
  }
  main {
    box-sizing: border-box;
    width: 100vw;
    padding: torem(27) torem(16) 0 torem(16);
  }

  .college_Journalism {
    @include between();
    width: torem(343);
    height: torem(108);
    padding: torem(16) torem(8) torem(16) torem(12);
    background: linear-gradient(
      left,
      rgba(154, 197, 255, 0.1),
      rgba(74, 148, 248, 0.1)
    );
    b {
      font-size: torem(16);
      color: rgba(74, 148, 248, 1);
    }
    p {
      max-width: torem(220);
      font-size: torem(12);
      line-height: torem(18);
      margin-top: torem(6);
      @extend .overflow;
      color: rgba(74, 148, 248, 1);
    }
    .Journalism_img {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }
    .van-button {
      border-radius: torem(4);
      @extend .buttonstyle;
      font-size: torem(12);
      span {
        display: inline-block;
        width: torem(60);
        @extend .overflow;
      }
    }
    > div {
      img {
        @extend .img;
      }
    }
    border-radius: torem(8);
  }
  .max-box {
    width: torem(343);
    height: torem(188.81);
    margin-top: torem(10);
    display: flex;
    justify-content: space-between;
    .left_box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: torem(167);
      height: 100%;
      .data_box {
        width: 100%;
        height: torem(84);
        border-radius: torem(8);
        display: flex;
        justify-content: space-between;
        background: linear-gradient(
          left,
          rgba(255, 178, 159, 0.1),
          rgba(255, 58, 12, 0.1)
        );
        padding: torem(16) torem(16) torem(16) torem(12);
        > div {
          font-size: torem(16);
          color: rgba(239, 125, 98, 1);
          img {
            @extend .img;
          }
        }
        .van-button {
          width: torem(68);
          height: torem(24);
          font-size: torem(12);
          span {
            display: inline-block;
            width: torem(68);
            @extend .overflow;
          }
          @extend .buttonstyle;
          border-radius: torem(4);
        }
      }
      .video_box {
        height: torem(90);
        width: 100%;
        border-radius: torem(8);
        padding: torem(15) torem(19) torem(16) torem(12);
        @include between();
        background: linear-gradient(
          left,
          rgba(255, 218, 189, 0.1),
          rgba(255, 113, 0, 0.1)
        );
        > div {
          color: rgba(240, 149, 77, 1);
          font-size: torem(16);
          .van-button {
            border-radius: torem(4);
            @extend .buttonstyle;
            font-size: torem(12);
            span {
              display: inline-block;
              width: torem(68);
              @extend .overflow;
            }
            margin-top: torem(12);
          }
          img {
            width: torem(41.49);
            height: torem(41.49);
          }
        }
        .video_img {
          img {
            margin-top: torem(7);
          }
        }
      }
    }
    .study_box {
      width: torem(166);
      box-sizing: border-box;
      height: 100%;
      b {
        font-size: torem(16);
        color: rgba(12, 170, 109, 1);
      }
      p {
        line-height: torem(18);
        font-size: torem(12);
        max-width: torem(142);
        text-overflow: ellipsis;
        display: -webkit-box;
        margin-top: torem(6);
        word-wrap: break-word;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 这里是超出几行省略 */
        overflow: hidden;
        color: rgba(12, 170, 109, 1);
      }
      background: linear-gradient(
        left,
        rgba(161, 240, 210, 0.1),
        rgba(0, 198, 121, 0.1)
      );
      .van-button {
        @extend .buttonstyle;
        font-size: torem(12);

        span {
          display: inline-block;
          width: torem(68);
          line-height: torem(24);
          @extend .overflow;
        }
        line-height: torem(24);
        border-radius: torem(4);
      }
      border-radius: torem(8);
      padding: torem(16) torem(12) torem(16) torem(12);
      > div {
        width: 100%;
        img {
          width: torem(50);
          height: torem(50);
        }
      }
      .study_img {
        text-align: end;
        margin-top: torem(13);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/college/index.vue